"use strict";

/* eslint-disable */
/* this file was taken directly from the CMS */
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initStatePicker = exports.getFipsCodeByState = exports.initSotuSources = exports.initAdjustments = exports.stateToFips = void 0;
const cash_dom_1 = __importDefault(require("cash-dom"));
const lodash_1 = require("lodash");
const lodash_debounce_1 = __importDefault(require("lodash.debounce"));
const query_string_1 = __importDefault(require("query-string"));
const charts_1 = require("./charts");
const tables_1 = __importDefault(require("./tables"));
const state = {};
const refreshCharts = (0, lodash_debounce_1.default)(() => {
  (0, charts_1.initCharts)();
  (0, charts_1.initChartEmbed)();
}, 1000);
exports.stateToFips = {
  wyoming: '56',
  wisconsin: '55',
  'west virginia': '54',
  washington: '53',
  virginia: '51',
  vermont: '50',
  utah: '49',
  texas: '48',
  tennessee: '47',
  'south dakota': '46',
  'south carolina': '45',
  'rhode island': '44',
  pennsylvania: '42',
  oregon: '41',
  oklahoma: '40',
  ohio: '39',
  'north dakota': '38',
  'north carolina': '37',
  'new york': '36',
  'new mexico': '35',
  'new jersey': '34',
  'new hampshire': '33',
  nevada: '32',
  nebraska: '31',
  montana: '30',
  missouri: '29',
  mississippi: '28',
  minnesota: '27',
  michigan: '26',
  massachusetts: '25',
  maryland: '24',
  maine: '23',
  louisiana: '22',
  kentucky: '21',
  kansas: '20',
  iowa: '19',
  indiana: '18',
  illinois: '17',
  idaho: '16',
  hawaii: '15',
  georgia: '13',
  florida: '12',
  'district of columbia': '11',
  delaware: '10',
  connecticut: '09',
  colorado: '08',
  california: '06',
  arkansas: '05',
  arizona: '04',
  alaska: '02',
  alabama: '01',
  usa: '00'
};
function updateDownloadButton(state) {
  const downloadButton = (0, cash_dom_1.default)('.metric__download-button');
  const downloadHrefRoot = downloadButton.attr('data-href');
  const downloadFileRoot = downloadButton.attr('data-download');
  const adjustedState = {
    ...state
  };
  if (adjustedState.state) {
    adjustedState.state = adjustedState.state.filter(item => item !== '00');
  }
  adjustedState.fips = adjustedState.state;
  delete adjustedState.state;
  downloadButton.attr('href', `${downloadHrefRoot}?${query_string_1.default.stringify(adjustedState)}`);
  if (adjustedState.adjustment) {
    downloadButton.attr('download', `${downloadFileRoot} (${adjustedState.adjustment}).csv`);
  } else {
    downloadButton.attr('download', `${downloadFileRoot}.csv`);
  }
}
function initAdjustments(metric) {
  const picker = (0, cash_dom_1.default)('#metric__adjustments-picker');
  const availableAdjustments = metric.adjustment_options;
  const query = query_string_1.default.parse(location.search);
  if ((0, cash_dom_1.default)('#metric__adjustments-picker .metric__adjustments').children().length > 0) {
    // Already exists, pass.
    return;
  }
  if (availableAdjustments.length > 0) {
    (0, cash_dom_1.default)(picker).removeAttr('hidden');
  }
  for (const adjustment of availableAdjustments) {
    let adjustmentString = adjustment.adjustment;
    if (adjustmentString === 'null') {
      adjustmentString = '';
    }
    (0, cash_dom_1.default)(picker).find('.metric__adjustments').append(`
      <label class="w-1/2 md:w-full block flex items-center mb-2 text-usafacts-gray text-sm">
        <input class="form-checkbox flex-shrink-0 text-usafacts-blue text-xl mr-2 border-2 border-gray-400" type="radio" name="adjustment" tabindex="0" data-adjustment="${adjustmentString}">
        <span>${adjustment.name}</span>
      </label>
    `);
  }
  // Preselect elements that are part of the query.
  if (query) {
    state.adjustment = query.adjustment;
    state.state = query.state;
    let {
      adjustment
    } = state;
    if (adjustment === 'null') {
      adjustment = '';
    }
    (0, cash_dom_1.default)(`#metric__adjustments-picker [data-adjustment='${adjustment}']`).prop('checked', true);
    updateDownloadButton(state);
  }
  (0, cash_dom_1.default)(picker).find('input').on('click', event => {
    const element = (0, cash_dom_1.default)(event.target);
    const adjustment = (0, cash_dom_1.default)(event.target).attr('data-adjustment');
    (0, cash_dom_1.default)('.data-metric-chart .dh-chart-wrapper .chart-loading').css('display', 'flex');
    (0, cash_dom_1.default)('.data-metric-chart .dh-chart-wrapper .chart-loading').css('background', 'rgba(255,255,255,.75)');
    if (state.adjustment === adjustment) {
      delete state.adjustment;
      (0, cash_dom_1.default)(event.target).prop('checked', false);
    } else {
      state.adjustment = adjustment;
    }
    history.pushState(null, '', `?${query_string_1.default.stringify(state)}`);
    updateDownloadButton(state);
    refreshCharts(state.adjustment, state.state);
  });
}
exports.initAdjustments = initAdjustments;
function initSotuSources(container, sources, meta) {
  const sourcesContainer = (0, cash_dom_1.default)(container).parent().parent().find('.metric__meta-modal');
  const toggleContainer = (0, cash_dom_1.default)(container).parent().parent().find('.sotu__sources-toggle');
  if (!sources.length && !meta.length) {
    (0, cash_dom_1.default)(toggleContainer).hide();
    return;
  }
  if (sources) {
    const sourceHtml = sources.map(source => `
        <div class="flex justify-between mt-2 md:mt-4">
          <div>
            <div class="text-xs sm:text-base font-bold text-gray-800"><a href="${source.url}" target="_blank">${source.agencyname}</a></div>
            ${source.name ? `<div class="text-2xs sm:text-sm text-gray-600"><a href="${source.url}" target="_blank">${source.name}</a></div>` : ''}
          </div>
          ${source.lastupdated ? `<div class="w-auto text-right flex-shrink-0 ml-4">
            <div class="text-xs sm:text-base font-bold text-gray-800">Last updated</div>
            <div class="text-2xs sm:text-sm text-gray-600">${source.lastupdated}</div>
          </div>` : ''}
        </div>
      `);
    (0, cash_dom_1.default)(sourcesContainer).append(`${sourceHtml.join('')}`);
  }
  if (meta) {
    const parsedMeta = {};
    for (const item of meta) {
      parsedMeta[item.type] = [];
      parsedMeta[item.type].push(item.data);
    }
    for (const prop in parsedMeta) {
      const propHtml = `
      <div class="text-xs font-bold mt-3 mb-3 text-gray-900">${prop}</div>
      `;
      const formattedMeta = parsedMeta[prop].map(item => `<div class="text-xs mb-3 italic text-gray-800">${item}</div>`);
      if (parsedMeta[prop].length > 0) {
        (0, cash_dom_1.default)(sourcesContainer).append(`${propHtml}${formattedMeta.join('')}`);
      }
    }
  }
  (0, cash_dom_1.default)(toggleContainer).on('click', () => {
    // Close all other open modals
    (0, cash_dom_1.default)('.metric__meta-modal').not(sourcesContainer).removeClass('active');
    // Open modal associated with toggle clicked
    (0, cash_dom_1.default)(sourcesContainer).toggleClass('active');
  });
  (0, cash_dom_1.default)(toggleContainer).on('keypress', e => {
    if (e.which === 13) {
      (0, cash_dom_1.default)(sourcesContainer).toggleClass('active');
    }
  });
  // Close modal with escape key
  document.addEventListener('keydown', e => {
    if (e.code === 'Escape') {
      if (sourcesContainer) {
        (0, cash_dom_1.default)(sourcesContainer).removeClass('active');
      }
    }
  });
}
exports.initSotuSources = initSotuSources;
function getFipsCodeByState(state) {
  return exports.stateToFips[state.toLowerCase()];
}
exports.getFipsCodeByState = getFipsCodeByState;
function initStatePicker(metric) {
  const picker = (0, cash_dom_1.default)('#metric__state-picker');
  const adjustments = null;
  const stateElements = (0, cash_dom_1.default)(picker).find('path');
  const queryState = query_string_1.default.parse(location.search).state;
  const toggleContainer = (0, cash_dom_1.default)(picker).find('.metric__state');
  const toggleHeading = (0, cash_dom_1.default)(picker).find('.metric__box-header');
  (0, cash_dom_1.default)(toggleHeading).on('click', function () {
    (0, cash_dom_1.default)(this).parent().toggleClass('active');
  });
  // Preselect elements that are part of the query.
  if (queryState) {
    state.state = [].concat(queryState);
    for (const item of state.state) {
      const key = (0, lodash_1.findKey)(exports.stateToFips, st => st === item);
      (0, cash_dom_1.default)(`[data-state='${key}']`).addClass('active');
    }
  }
  (0, cash_dom_1.default)(stateElements).on('click', function (event) {
    const chosenState = (0, cash_dom_1.default)(this).attr('data-state');
    const stateCode = getFipsCodeByState(chosenState.split('-').join(' '));
    (0, cash_dom_1.default)(`#metric__state-picker [data-state='${chosenState}']`).toggleClass('active');
    (0, cash_dom_1.default)('.data-metric-chart .dh-chart-wrapper .chart-loading').css('display', 'flex');
    (0, cash_dom_1.default)('.data-metric-chart .dh-chart-wrapper .chart-loading').css('background', 'rgba(255,255,255,.75)');
    state.state = [].concat(state.state);
    if (state.state) {
      const index = state.state.indexOf(stateCode);
      if (index > -1) {
        state.state.splice(index, 1);
      } else {
        state.state.push(stateCode);
      }
    } else {
      state.state = [];
      state.state.push(stateCode);
    }
    history.pushState(null, '', `?${query_string_1.default.stringify(state)}`);
    refreshCharts(state.adjustment, state.state);
    if ((0, cash_dom_1.default)('#finance-table-container').length > 0) {
      var _state$state;
      (0, cash_dom_1.default)('#finance-table-container').attr('data-states', JSON.stringify(state.state));
      (0, cash_dom_1.default)('#finance-table-container').attr('data-geo', !!((_state$state = state.state) !== null && _state$state !== void 0 && _state$state.length) ? '1' : '0');
      (0, tables_1.default)();
    } else {
      updateDownloadButton(state);
    }
  });
}
exports.initStatePicker = initStatePicker;
function default_1() {
  initStatePicker();
}
exports.default = default_1;